import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ReviewPage } from "./pages/ReviewPage";
import { LoginPage, isAuthenticated } from "./pages/LoginPage";

const App: React.FC = () => {
  // Track auth state in component state so the tree re-renders on login.
  // isAuthenticated() reads sessionStorage, so it survives page navigations.
  const [authed, setAuthed] = useState(isAuthenticated);

  if (!authed) {
    return <LoginPage onSuccess={() => setAuthed(true)} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/review" element={<ReviewPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
